import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getDocs, collection, query, where } from "firebase/firestore";
import { db } from "../../db/firebaseConfig";

import ItemList from "../ItemList/ItemList";

const ItemListContainer = () => {
  const [producto, setProducto] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(4); // 👈 mostrar de a 4

  const { categoryId, subcategoryId } = useParams();

  useEffect(() => {
    setLoading(true);

    let collectionRef = collection(db, "producto");

    if (categoryId && subcategoryId) {
      collectionRef = query(
        collectionRef,
        where("category", "==", categoryId),
        where("subcategory", "==", subcategoryId)
      );
    } else if (categoryId) {
      collectionRef = query(
        collectionRef,
        where("category", "==", categoryId)
      );
    }

    getDocs(collectionRef)
      .then((response) => {
        const productoAdapted = response.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducto(productoAdapted);
      })
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  }, [categoryId, subcategoryId]);

  if (loading) {
    return (
      <h2 className="text-center py-4 text-5xl bg-[#F3F4F6] mt-16 lg:mt-20">
        Cargando...
      </h2>
    );
  }

  return (
    <div className="p-6">
      <ItemList producto={producto.slice(0, visibleCount)} /> {/* 👈 solo 4 */}
      {visibleCount < producto.length && (
        <div className="flex justify-center mt-4">
          <button
            onClick={() => setVisibleCount((prev) => prev + 4)}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            Ver más
          </button>
        </div>
      )}
    </div>
  );
};

export default ItemListContainer;
